import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthenticationStep, CognitoAuthProvider, CustomAuthProvider } from '../constants';

export const NAMESPACE = 'social';

export const initialState = {
  provider: {
    type: undefined as CognitoAuthProvider | CustomAuthProvider | undefined,
    redirect: '',
    step: '',
  },
};

const socialSlice = createSlice({
  name: NAMESPACE,
  initialState,
  reducers: {
    setSocialProvider(
      state,
      action: PayloadAction<{
        type: CognitoAuthProvider | CustomAuthProvider;
        redirect?: string;
        step?: AuthenticationStep;
      }>
    ) {
      state.provider = {
        type: action?.payload?.type,
        redirect: action?.payload?.redirect || '',
        step: action?.payload?.step || AuthenticationStep.LOGIN,
      };
    },
    clearSocialProvider(state) {
      state.provider = {
        type: undefined,
        redirect: '',
        step: '',
      };
    },
  },
});

export default socialSlice;
